import { PageErrorNoRouting } from '../../pages/PageError'
import EqxErrorBoundary from '../../shared/components/EqxErrorBoundary'

import '@fortawesome/fontawesome-free/css/all.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../assets/bootstrap.scss'

import '../../assets/Continuum.css'

import '../../assets/App.css'
import '../../assets/Continuum-bi.css'

import '../../assets/login.css'

//import { AuthProvider } from './components/Auth';

import AppApiProvider from './AppApi'
import AppAuthProvider from './AppAuth'
import AppBaseConfigProvider from './AppBaseConfig'
import AppContinuumSharedApiProvider from './AppContinuumSharedApiProvider'
import AppEnvironmentProvider from './AppEnvironment'
import AppMaintenanceHandlerProvider from './AppMaintenanceHandler'
import AppRouter from './AppRouter'
import AppTenantProvider from './AppTenant'
import AppTenantIDProvider from './AppTenantID'
import AppTenantLookupProvider from './AppTenantLookupProvider'

// app
// - error boundary
// - - config
// - - - api
// - - - - tenant
// - - - - - auth provider (gets config)
// - - - - - - router
// - - - - - - - token provider (require auth)
// - - - - - - - - main layout
// - - - - - - - - - page

/**
 * configure the app
 */

interface AppProps { }
const App = (props: AppProps) => {
    return (
        <>
            <EqxErrorBoundary fallback={<PageErrorNoRouting />}>
                <AppEnvironmentProvider>
                    <AppBaseConfigProvider>
                        <AppTenantIDProvider>
                            <AppTenantLookupProvider>
                                <AppApiProvider>
                                    <AppContinuumSharedApiProvider>
                                        <AppMaintenanceHandlerProvider>
                                            <AppTenantProvider>
                                                <AppAuthProvider>
                                                    <AppRouter />
                                                </AppAuthProvider>
                                            </AppTenantProvider>
                                        </AppMaintenanceHandlerProvider>
                                    </AppContinuumSharedApiProvider>
                                </AppApiProvider>
                            </AppTenantLookupProvider>
                        </AppTenantIDProvider>
                    </AppBaseConfigProvider>
                </AppEnvironmentProvider>
            </EqxErrorBoundary>
        </>
    )
}

export default App

